import {INIT_APP} from '~/ViewFabricGreetingCard/reducers/constants';
import {UPDATE_GUEST_INFO} from './constants';

export const initialState = window.guest ?? {};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case INIT_APP: {
      const {guest} = action.payload;
      return guest;
    }
    case UPDATE_GUEST_INFO:
      return {...state, ...action.payload};
    default:
      return state;
  }
};
